import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import Dropdown from 'react-toolbox/lib/dropdown';

const defaults = {
  orderStatus: 'Todo'
};

class BoxCountChartSettings extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      outdata: {
        ...defaults,
        ...props.indata
      }
    };
  }

  componentDidMount() {
    this.onChange();
  }

  onChange() {
    this.props.onChange(this.state.outdata);
  }

  onOrderStatusChange(val) {
    this.setOutdataValue('orderStatus', val);
  }

  setOutdataValue(property, value) {
    this.setState(
      { outdata: { ...this.state.outdata, [property]: value } },
      this.onChange
    );
  }

  render() {
    const orderStatuses = [
      { value: 'Todo', label: 'Todo' },
      { value: 'Distributor', label: 'Distributor' }
    ];

    return (
      <div>
        <Input
          value={this.state.outdata.title}
          onChange={val => this.setOutdataValue('title', val)}
          label="Title"
        />
        <Dropdown
          onChange={val => this.onOrderStatusChange(val)}
          source={orderStatuses}
          value={this.state.outdata.orderStatus}
          label="Order status"
        />
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, null, null, { pure: false })(
  BoxCountChartSettings
);



// WEBPACK FOOTER //
// ./app/widgets/BoxCountChart/settings.js